import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { UserRole } from '../../types';
import { ArrowRight, Loader2, Lock } from 'lucide-react';
export function LoginForm() {
  const [step, setStep] = useState<'email' | 'otp'>('email');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState<UserRole>('tenant');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const {
    login,
    isLoading
  } = useAuth();
  const navigate = useNavigate();
  const handleEmailSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) setStep('otp');
  };
  const handleOtpChange = (index: number, value: string) => {
    if (value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (otp.join('').length === 6) {
      await login(email, role);
      navigate(role === 'admin' ? '/admin/dashboard' : `/${role}/dashboard`);
    }
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-519">
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-520">
        <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-blue-200/30 rounded-full blur-3xl" data-id="element-521"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-green-200/30 rounded-full blur-3xl" data-id="element-522"></div>
      </div>

      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-523">
        <div className="flex justify-center mb-8" data-id="element-524">
          <Link to="/" data-id="element-525">
            <img src="https://cdn.magicpatterns.com/uploads/7EjErFNEa8ZC1es35aEHqt/RENTA_logo.png" alt="Renta" className="h-14 w-auto drop-shadow-sm hover:scale-105 transition-transform" data-id="element-526" />
          </Link>
        </div>
        <h2 className="text-center text-3xl font-extrabold text-gray-900 tracking-tight" data-id="element-527">
          Welcome Back
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-528">
          Secure access to your dashboard
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-529">
        <div className="bg-white py-8 px-4 shadow-xl shadow-gray-200/50 sm:rounded-2xl sm:px-10 border border-gray-100" data-id="element-530">
          {step === 'email' ? <form className="space-y-6" onSubmit={handleEmailSubmit} data-id="element-531">
              <div data-id="element-532">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-533">
                  I am a
                </label>
                <div className="grid grid-cols-2 gap-3 p-1 bg-gray-50 rounded-lg border border-gray-200" data-id="element-534">
                  {(['tenant', 'landlord', 'admin'] as const).map(r => <button key={r} type="button" onClick={() => setRole(r)} className={`flex justify-center py-2 px-4 rounded-md text-sm font-medium capitalize transition-all duration-200 ${role === r ? 'bg-white text-blue-600 shadow-sm ring-1 ring-gray-200' : 'text-gray-500 hover:text-gray-900'}`} data-id="element-535">
                      {r}
                    </button>)}
                </div>
              </div>

              <div data-id="element-536">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-537">
                  Email address
                </label>
                <div className="mt-1" data-id="element-538">
                  <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="appearance-none block w-full px-4 py-3 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent sm:text-sm transition-all" placeholder="you@example.com" data-id="element-539" />
                </div>
              </div>

              <div data-id="element-540">
                <button type="submit" className="w-full flex justify-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all hover:shadow-lg hover:-translate-y-0.5" data-id="element-541">
                  Continue
                  <ArrowRight className="ml-2 h-4 w-4" data-id="element-542" />
                </button>
              </div>
            </form> : <form className="space-y-6" onSubmit={handleLogin} data-id="element-543">
              <div data-id="element-544">
                <div className="text-center mb-6" data-id="element-545">
                  <div className="mx-auto w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center mb-4" data-id="element-546">
                    <Lock className="h-6 w-6 text-blue-600" data-id="element-547" />
                  </div>
                  <label className="block text-sm font-medium text-gray-700" data-id="element-548">
                    Enter the 6-digit code sent to{' '}
                    <span className="font-bold text-gray-900" data-id="element-549">{email}</span>
                  </label>
                </div>

                <div className="flex justify-between gap-2" data-id="element-550">
                  {otp.map((digit, idx) => <input key={idx} id={`otp-${idx}`} type="text" maxLength={1} value={digit} onChange={e => handleOtpChange(idx, e.target.value)} className="w-12 h-14 text-center text-2xl font-bold border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" data-id="element-551" />)}
                </div>

                <div className="text-center mt-6 p-3 bg-blue-50 rounded-lg border border-blue-100" data-id="element-552">
                  <p className="text-xs text-blue-700" data-id="element-553">
                    Demo Code:{' '}
                    <span className="font-mono font-bold text-lg" data-id="element-554">123456</span>
                  </p>
                </div>
              </div>

              <div data-id="element-555">
                <button type="submit" disabled={isLoading} className="w-full flex justify-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 transition-all hover:shadow-lg" data-id="element-556">
                  {isLoading ? <Loader2 className="h-5 w-5 animate-spin" data-id="element-557" /> : 'Verify & Sign In'}
                </button>
              </div>

              <div className="text-center" data-id="element-558">
                <button type="button" onClick={() => setStep('email')} className="text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors" data-id="element-559">
                  ← Back to email
                </button>
              </div>
            </form>}
        </div>

        <p className="mt-8 text-center text-sm text-gray-500" data-id="element-560">
          Don't have an account?{' '}
          <Link to="/signup" className="font-bold text-blue-600 hover:text-blue-500" data-id="element-561">
            Sign up for free
          </Link>
        </p>
      </div>
    </div>;
}